import React, { useState, useEffect, useRef } from 'react';
import { Plus, Search, Filter, ChevronDown, LayoutGrid, List } from 'lucide-react';
import EventModal from './NewShiftModal';
import ShiftModal from './AddShiftModal';
import SuccessModal from '../../../components/ConfirmModal/SuccessModal';
import { getShiftLog } from '../../../services/superAdminServices'; // ✅ ADD THIS

interface DashboardHeaderProps {
  onShiftCreated?: () => void;
  onSearch?: (query: string) => void;
  readOnly?: boolean;
}

const DashboardHeader = ({ onShiftCreated, onSearch, readOnly = false }: DashboardHeaderProps) => {
  const [open, setOpen] = useState(false);
  const [successModal, setSuccessModal] = useState(false);
  const [searchQuery, setSearchQuery] = useState('');
  const debounceRef = useRef<ReturnType<typeof setTimeout> | null>(null);

  // ✅ UPDATED: now also calls API
  useEffect(() => {
    if (debounceRef.current) clearTimeout(debounceRef.current);

    debounceRef.current = setTimeout(async () => {
      try {
        onSearch?.(searchQuery);
      } catch (error) {
        console.error('Search API error:', error);
      }
    }, 500);

    return () => {
      if (debounceRef.current) clearTimeout(debounceRef.current);
    };
  }, [searchQuery]);

  return (
    <div className="flex justify-between items-center px-6 py-4 bg-white border-b">
      {/* Left Side: New Shift Button */}
      {readOnly ? (
        <div />
      ) : (
        <button
          className="flex items-center gap-2 bg-[#e84545] text-white px-4 py-2 rounded-md text-sm font-medium hover:opacity-90 -ml-6"
          onClick={() => setOpen(true)}
        >
          <Plus size={16} /> New Shift
        </button>
      )}

      {open && (
        <ShiftModal
          onClose={() => {
            setOpen(false);
            onShiftCreated?.();
          }}
          onSave={(data) => {
            setSuccessModal(true);
            setOpen(false);
          }}
        />
      )}

      <SuccessModal
        isOpen={successModal}
        onClose={() => setSuccessModal(false)}
        title="Event Added"
        message="The event has been successfully logged."
        buttonText="OK"
        onButtonClick={() => setSuccessModal(false)}
      />

      {/* Right Side: Controls */}
      <div className="flex items-center gap-3">
        {/* Search Input */}
        <div className="flex items-center border rounded-md px-2 py-1 bg-white text-sm text-gray-700">
          <Search size={16} className="mr-2 text-[#0c1a3e]" />
          <input
            type="text"
            placeholder="Search"
            className="outline-none border-none w-36 text-sm placeholder-gray-400"
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
          />
        </div>

        {/* Filter Button */}
        {/*<button className="flex items-center gap-1 px-3 py-1.5 border rounded-md bg-white text-[#0c1a3e] text-sm">
          <Filter size={16} /> Filter
        </button>/*}

        {/* Dropdown Button */}
        {/*<button className="flex items-center gap-1 px-3 py-1.5 border rounded-md bg-white text-[#0c1a3e] text-sm">
          Created Work Permits <ChevronDown size={16} />
        </button>*/}

        {/* View Toggle Buttons */}
        {/*<div className="flex border rounded-md overflow-hidden">
          <button className="px-2 py-1 bg-red-100 text-red-600">
            <List size={16} />
          </button>}
          <button className="px-2 py-1 hover:bg-gray-100">
            <LayoutGrid size={16} />
          </button>
        </div>*/}
      </div>
    </div>
  );
};

export default DashboardHeader;
